import { notify } from 'utils/reduxUtils';

export const types = {
  CONTACT_SEARCH_ERROR: 'common/contactSelector/CONTACT_SEARCH_ERROR',
  CONTACT_SEARCH_REQUEST: 'common/contactSelector/CONTACT_SEARCH_REQUEST',
  CONTACT_SEARCH_SUCCESS: 'common/contactSelector/CONTACT_SEARCH_SUCCESS',
  FETCH_CONTACT_REQUEST: 'common/contactSelector/FETCH_CONTACT_REQUEST',
  FETCH_CONTACT_SUCCESS: 'common/contactSelector/FETCH_CONTACT_SUCCESS',
  PAGINATE_CONTACT_ERROR: 'common/contactSelector/PAGINATE_CONTACT_ERROR',
  PAGINATE_CONTACT_REQUEST: 'common/contactSelector/PAGINATE_CONTACT_REQUEST',
  PAGINATE_CONTACT_SUCCESS: 'common/contactSelector/PAGINATE_CONTACT_SUCCESS',
};

export const contactSearch = {
  request: ({ search, searchFields, searchFilters, paginateFrom }) => ({
    type: types.CONTACT_SEARCH_REQUEST,
    payload: { search, searchFields, searchFilters, paginateFrom },
  }),
  success: ({ searchResults, count }) => ({
    type: types.CONTACT_SEARCH_SUCCESS,
    payload: { searchResults, count },
  }),
  error: notify(
    (error) => ({
      type: types.CONTACT_SEARCH_ERROR,
      payload: error,
    }),
    "Can't fetch contacts",
  ),
};

export const fetchContact = {
  request: ({ contactId }) => ({
    type: types.FETCH_CONTACT_REQUEST,
    payload: { contactId },
  }),
  success: ({ contact }) => ({
    type: types.FETCH_CONTACT_SUCCESS,
    payload: { contact },
  }),
};

export const paginateContacts = {
  request: ({ searchFields, searchFilters, paginateFrom }) => ({
    type: types.PAGINATE_CONTACT_REQUEST,
    payload: { searchFields, searchFilters, paginateFrom },
  }),
  success: ({ searchResults }) => ({
    type: types.PAGINATE_CONTACT_SUCCESS,
    payload: { searchResults },
  }),
  error: notify(
    (error) => ({
      type: types.PAGINATE_CONTACT_ERROR,
      payload: error,
    }),
    "Can't paginate contacts",
  ),
};
